export function calculateAverage(sum: number, count: number): number {
  return sum / (count || 1);
}
